import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Plus, Minus } from 'lucide-react';
import { zeditFAQ } from '../../data/zeditContent';

const ZeditFAQ = () => {
  const [open, setOpen] = useState(0);
  const [ref, inView] = useInView({ threshold: 0.1, triggerOnce: true });

  return (
    <section ref={ref} className="py-20 sm:py-28 relative">
      <div className="container mx-auto px-5 sm:px-8 max-w-4xl">
        <div className="text-center mb-12 sm:mb-14">
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-[var(--accent-primary)]">
            // Questions answered
          </span>
          <h2 className="mt-3 text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight text-white">
            Frequently asked
          </h2>
          <p className="mt-4 text-base font-light text-[var(--text-secondary)]">
            Quick answers about how Zedit works.
          </p>
        </div>

        <div className="space-y-3">
          {zeditFAQ.map((f, i) => (
            <motion.div
              key={f.q}
              initial={{ opacity: 0, y: 12 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ delay: i * 0.05 }}
              className="rounded-2xl bg-[var(--bg-secondary)] border border-[var(--border-subtle)] hover:border-[var(--accent-primary)]/30 overflow-hidden transition-colors"
            >
              <button
                onClick={() => setOpen(open === i ? -1 : i)}
                data-testid={`zedit-faq-q-${i}`}
                className="w-full flex items-center justify-between gap-4 p-5 sm:p-6 text-left text-white"
              >
                <span className="text-sm sm:text-base font-semibold">{f.q}</span>
                <div
                  className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 transition-colors"
                  style={{
                    background: open === i ? 'var(--accent-primary)' : 'var(--bg-tertiary)',
                    color: open === i ? '#000' : '#fff',
                  }}
                >
                  {open === i ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
                </div>
              </button>
              {open === i && (
                <div className="px-5 sm:px-6 pb-5 sm:pb-6 text-sm font-light text-[var(--text-secondary)] leading-relaxed">
                  {f.a}
                </div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ZeditFAQ;
